export default __webpack_public_path__ + "static/relationshipChart-8fd8db10150ca9c5a83cc245c20cb369.gif";